import React, { useRef, useState } from 'react'
import { Select, Table, Space } from 'antd'
import { Line } from 'react-chartjs-2'
import { useAsync } from 'react-use'
import PageLayout from '@layouts/PageLayout'
import { useLocalization } from '@contexts/LocalizationContext'
import { growthLabels } from '@constants'
import Fetch from '@components/CRUD/Fetch'
import { client } from '@utils/client'

const { Option } = Select

const MaleTab = () => {
  const defaultPage = 1
  const defaultPageSize = 10
  const fetchRef = useRef(null)
  const [page, setpage] = useState(defaultPage)
  const [pageSize, setpageSize] = useState(defaultPageSize)
  const { t } = useLocalization()
  const [version, setVersion] = useState()

  const state = useAsync(async () => {
    const versions = await client
      .get('/standard/versions', {
        params: { type: 'height', sex: 'male' },
      })
      .then((res) => res.data)
    const result = versions.map((item) => item.version).sort((a, b) => b - a)
    if (result.length > 0) {
      setVersion(result[0])
    }
    return result
  }, [])

  const changeVersion = (v) => {
    setVersion(v)
  }

  const handleChange = (pagination) => {
    setpage(pagination.current)
    setpageSize(pagination.pageSize)
  }

  const fetch = async ({ page, pageSize, version }) => {
    const result = await client
      .get('/standard', {
        params: {
          where: JSON.stringify({
            type: 'height',
            sex: 'male',
            version,
          }),
          skip: (page - 1) * pageSize,
          limit: pageSize,
        },
      })
      .then((res) => res.data)
    const dataChart = {
      labels: result.data.map((item) => item.ageMo),
      datasets: growthLabels.map(({ label, color }) => ({
        label,
        data: result.data.map((item) => item.data[label]),
        fill: false,
        backgroundColor: color,
        borderColor: color,
        yAxisID: 'y-axis-1',
      })),
    }
    return { ...result, dataChart }
  }

  const columns = [
    {
      title: t('height.listScreen.column.sex'),
      dataIndex: 'sex',
      key: 'sex',
      width: '20%',
    },
    {
      title: t('height.listScreen.column.age'),
      dataIndex: 'ageMo',
      key: 'ageMo',
      width: '20%',
    },
    ...growthLabels.map((item) => ({
      title: item.label,
      // dataIndex: item.label,
      // dataIndex: `data.${item.label}`,
      key: item.label,
      width: '10%',
      render: (record) => {
        return record.data[item.label]
      },
    })),
  ]

  const options = {
    scales: {
      yAxes: [
        {
          type: 'linear',
          display: true,
          position: 'left',
          id: 'y-axis-1',
          scaleLabel: {
            display: true,
            labelString: t('height.listScreen.yAxesLabel'),
          },
        },
      ],
      xAxes: [
        {
          position: 'bottom',
          scaleLabel: {
            display: true,
            labelString: t('height.listScreen.xAxesLabel'),
          },
        },
      ],
    },
  }

  return (
    <Fetch fetch={fetch} params={{ page, pageSize, version }} ref={fetchRef}>
      {({ data, total, dataChart }) => (
        <PageLayout
          title={t('height.listScreen.maleTitle')}
          shownBack={false}
          createPath="/height/create/male"
          extra={[
            <span key="version">
              <Select
                style={{ width: 100 }}
                onSelect={changeVersion}
                value={version}
              >
                {(state.value || []).map((v) => (
                  <Option key={v} value={v}>
                    v. {v}
                  </Option>
                ))}
              </Select>
            </span>,
          ]}
        >
          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Line data={dataChart} options={options} />
            <Table
              rowKey="id"
              columns={columns}
              dataSource={data}
              onChange={handleChange}
              pagination={{
                defaultCurrent: defaultPageSize,
                defaultPageSize: defaultPageSize,
                current: page,
                pageSize,
                total,
              }}
            />
          </Space>
        </PageLayout>
      )}
    </Fetch>
  )
}

export default MaleTab
